import { FlagEmoji } from '@/components/atoms/FlagEmoji/FlagEmoji';
import { countryCodeByLanguage } from '@/shared/languageCodes';

export const LanguageFlag = ({ code }: { code: string }) => {
  const countryCode = countryCodeByLanguage[code]?.toLowerCase();
  return countryCode ? <FlagEmoji countryCode={countryCode} /> : null;
};
